import { Injectable, inject } from '@angular/core';

import { CasinoCoreGamelaunchService, GameLaunch } from '@casinocore/platform/core';
import { DeviceService } from '@frontend/vanilla/core';

import { GameModel } from '../models/gametile.models';
import { SubcategoryModel } from '../models/modular-lmt-category.models';

@Injectable({
    providedIn: 'root',
})
export class ModularGameLaunchService {
    private readonly casinoCoreGameLaunchService = inject(CasinoCoreGamelaunchService);
    private readonly deviceService = inject(DeviceService);

    readonly isMobile = this.deviceService.isMobile;
    readonly isTablet = this.deviceService.isTablet;

    clickHandler(game: GameModel | undefined, category: SubcategoryModel) {
        const gameModel = this.getGameLaunch(game, category);
        this.casinoCoreGameLaunchService.launchGame(gameModel);
    }
    private getGameLaunch(game: GameModel | undefined, category: SubcategoryModel): GameLaunch {
        const gameModel = new GameLaunch();
        gameModel.game = game;
        gameModel.isTouch = this.isMobile || this.isTablet;
        gameModel.gamePosition = game?.gameIndex ?? 1;
        gameModel.categoryType = category?.categoryid ?? '';
        gameModel.from = 'Top10Games';
        gameModel.replaceRouteInHistory = false;
        gameModel.isDemoLaunch = false;
        gameModel.skipUnfinGame = false;
        gameModel.gameLaunchedFrom = 'Top10Games';
        gameModel.gridPosition = 1;
        gameModel.gameContainer = game?.gameContainer ?? '';
        gameModel.clickTimeStamp = this.casinoCoreGameLaunchService.currentTimeStamp();
        return gameModel;
    }
}
